import {
  SlBreadcrumb
} from "./chunk.AO5RQAZ5.js";

// src/components/breadcrumb/breadcrumb.ts
var breadcrumb_default = SlBreadcrumb;
SlBreadcrumb.define("sl-breadcrumb");

export {
  breadcrumb_default
};
